import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ConnectableObservable ,  Observable } from "rxjs";
import { publishReplay } from "rxjs/operators";
import { withSpinner } from "../../extensions/withSpinner.extension";
import { API_ROOT } from "../../types/constants/appconstants";

@Injectable({
    "providedIn": "root"
})
export class RoleService {
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private roleServiceBaseUrl = this.apiRoot + "api/roles";
    private rolesObs: ConnectableObservable<any[]>;

    constructor() {
        this.rolesObs = withSpinner(this.http).get<any>(this.roleServiceBaseUrl).pipe(
            publishReplay()
        ) as ConnectableObservable<any>;
        this.rolesObs.connect();
    }

    getRoles (): Observable<any[]> {
        return this.rolesObs;
    }
}
